/**
 * Client-side audit forwarder.
 * Server is the source of truth (WORM hash-chained log);
 * this fires non-blocking telemetry for compliance + observability.
 */
export interface ClientAuditEvent {
  action: string;
  outcome: "success" | "failure";
  httpStatus?: number;
  resourceType?: string;
  resourceId?: string;
  metadata?: Record<string, unknown>;
}

export function auditClientEvent(event: ClientAuditEvent): void {
  if (typeof window === "undefined") return;
  // Non-blocking; failures are silent (server audit is the real one)
  try {
    const body = JSON.stringify({ ...event, ts: new Date().toISOString() });
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/audit/client", body);
    } else {
      fetch("/api/audit/client", { method: "POST", body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* never throw from audit */
  }
}
